import React,{FC, useState, useEffect, useRef} from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import { Card, Row, Col, Form, Button, Dropdown, Image } from "react-bootstrap";
import {useIntl} from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'
import CommodityDropdown from "./components/CommodityDropdown";
import { getTradeDistributionData, getTradeHistoricalData } from "./core/_requests";
import { TradePotentialChart } from "./components/TradePotentialChart";
import { TradeHistoricalChart } from "./components/TradeHistoricalChart";
import { Toast } from "../../../../ui-kit";

const TradePotentialCommodityPage: FC =  () => {
  const intl = useIntl()
  const { hs_code } = useParams();
  const navigate = useNavigate();
  const btnSearchRef = useRef(null)
  const [onChangeSelectedHS, setOnChangeSelectedHS] = useState<any|null>(null)
  const [selectedHS, setSelectedHS] = useState<any|null>(null)
  const [isDisableBtnSearch, setIsDisableBtnSearch] = useState(true)
  const [showResultSection, setShowResultSection] = useState(false)
  const [importChartData, setImportChartData] = useState<any|null>(null)
  const [exportChartData, setExportChartData] = useState<any|null>(null)
  const [importHistoricalTradeData, setImportHistoricalTradeData] = useState<any|null>(null)
  const [exportHistoricalTradeData, setExportHistoricalTradeData] = useState<any|null>(null)

  const handleSelectHS = (hs:any) => {
    setOnChangeSelectedHS(hs)
    if(hs && hs_code){
      setSelectedHS(hs)
    }
    setIsDisableBtnSearch(false)
  }

  useEffect(() => { if (selectedHS && hs_code) { handleBtnSearch(); 
      navigate(`/trade-prospect-commodity`); } }, [selectedHS, hs_code]);

  const handleBtnSearch = () =>{
    setIsDisableBtnSearch(true)
    setShowResultSection(true)
    setImportChartData(null)
    setExportChartData(null)
    setImportHistoricalTradeData(null)
    setExportHistoricalTradeData(null)
    setSelectedHS(onChangeSelectedHS)
    if (onChangeSelectedHS) {
    // Get Sayken Chart Data
      Promise.allSettled([
        getTradeDistributionData(onChangeSelectedHS.hs, 'imports', 2023),
        getTradeDistributionData(onChangeSelectedHS.hs, 'exports', 2023),
        getTradeHistoricalData(onChangeSelectedHS.hs, 'exports'),
        getTradeHistoricalData(onChangeSelectedHS.hs, 'imports')
      ]).then(results => {
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            const data = result.value.data.data;
            if (data?.length > 0) {
              switch (index) {
                case 0:
                  setImportChartData(data);
                  break;
                case 1:
                  setExportChartData(data);
                  break;
                case 2:
                  setExportHistoricalTradeData(data);
                  break;
                case 3:
                  setImportHistoricalTradeData(data);
                  break;
                default:
                  break;
              }
            }
          } else {
            console.error(result.reason);
            switch (index) {
                case 0:
                  setImportChartData([]);
                  break;
                case 1:
                  setExportChartData([]);
                  break;
                case 2:
                  setExportHistoricalTradeData([]);
                  break;
                case 3:
                  setImportHistoricalTradeData([]);
                  break;
                default:
                  break;
              }
            // Show error toast here
            // Toast('An error occurred while fetching the data', 'danger', 'Please try again later');
          }
        });
      }).catch(e => {
        console.error('Unexpected error:', e);
        Toast('Unexpected error occurred', 'danger',e.message);
      });
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[{
        title: 'Home',
        path: '/',
        isSeparator: false,
        isActive: false,
      },
      {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
      },]}>{intl.formatMessage({id: 'MENU.TRADE_POTENTIAL'})}
      </PageTitle>
      <Row className="mb-5">
        <Col>
          <Card className="card-custom card-border">
            <Card.Body className="d-flex justify-content-around align-items-center">
              <Image src="/media/tina/img-result-market.jpg" thumbnail width={110}/>
              <div  className="ms-5 d-flex flex-column justify-content-center">
                <h3 className="text-primary">Trade Prospects
                  <span className="text-gray-700">
                    <span className="fa-solid fa-angles-right px-1"></span>
                    evaluate the trade prospects for Cambodia
                  </span> 
                </h3>
                <div className="text-gray-700">Explore the projected trade prospects of selected countries from each available year. Analyze key economic indicators to identify opportunities for enhancing international trade relations and maximizing economic benefits.</div>
              </div>
            </Card.Body>
          </Card>  
        </Col>
      </Row>
      <Row className="mb-5">
        <Col>
          <Card>
            <Card.Header className="card-header-stretch">
              <Card.Title>
                <span className="fa fa-magnifying-glass px-2"></span>
                <h3 className='text-gray-700'>Search the prospect commodity</h3>   
              </Card.Title>
            </Card.Header>  
            <Card.Body>
              <Form.Group className="mb-3"> 
                <Form.Label>Commodity</Form.Label> 
                <div className="d-flex align-items-center"> 
                  <CommodityDropdown onSelect={handleSelectHS} selectedHS={hs_code}/>
                  <Button className="ms-2 w-25" variant="primary" size="sm" onClick={handleBtnSearch} disabled={isDisableBtnSearch} ref={btnSearchRef}>
                    <i className="fa-solid fa-magnifying-glass fa-rotate-90 fs-9 me-2"></i>Search
                  </Button> 
                </div>
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {showResultSection?(
        <Row className="mb-5">
          <Col>
            <Card>
              <Card.Header className="card-header-stretch">
                <Card.Title>
                  <span className="fa-solid fa-chart-simple px-2"></span>
                  <h3 className='text-gray-700'>Trade Prospectof {selectedHS?.hs} by Cambodia</h3>   
                </Card.Title>
              </Card.Header>  
              <Card.Body>
                <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x nav-stretch fs-6 border-0">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-bs-toggle="tab"
                      href="#kt_tab_pane_4"
                    >
                      <i className="bi bi-box-arrow-right"></i>&nbsp;Exported Commodity of {selectedHS?.hs} by Cambodia
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#kt_tab_pane_5"
                    >
                      <i className="bi bi-box-arrow-in-left"></i>&nbsp;Imported Commodity of {selectedHS?.hs} by Cambodia
                    </a>
                  </li> */}
                </ul>
                <div className="tab-content h-100" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="kt_tab_pane_4"
                    role="tabpanel"
                  >
                    {(exportChartData?.length===0 || exportHistoricalTradeData?.length===0) ? (
                        <Row className="mt-10 card-border">
                          <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                            <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
                              <i className="fa-solid fa-triangle-exclamation"></i>
                            </span>
                            <div className="d-flex flex-column">
                              <h5 className="mb-1">Data Not Found</h5>
                              <span>Unfortunately, we couldn't find any export data of {selectedHS?.hs} commodity. Please check other commodities.</span>
                            </div>
                          </div>
                        </Row>
                    ):(
                      <>
                        <Row className="mt-10 card-border">
                          <TradePotentialChart data={exportChartData}/>
                        </Row>
                        <div className="separator my-10"></div>
                        <Row>
                          <TradeHistoricalChart 
                            data={exportHistoricalTradeData} 
                            hs={selectedHS?.hs} 
                            tradeflow='exports'/>
                        </Row>
                      </>
                    )}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="kt_tab_pane_5"
                    role="tabpanel"
                  >
                    {(importChartData?.length===0 || importHistoricalTradeData?.length===0) ? (
                      <Row className="mt-10 card-border">
                        <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                          <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
                            <i className="fa-solid fa-triangle-exclamation"></i>
                          </span>
                          <div className="d-flex flex-column">
                            <h5 className="mb-1">Data Not Found</h5>
                            <span>Unfortunately, we couldn't find any export data of {onChangeSelectedHS?.hs} commodity. Please check other commodities.</span>
                          </div>
                        </div>
                      </Row>
                    ):(
                    <>
                      <Row className="mt-10 card-border">
                        <TradePotentialChart data={importChartData}/>
                      </Row>
                      <div className="separator my-10"></div>
                      <Row>
                        <TradeHistoricalChart 
                          data={importHistoricalTradeData} 
                          hs={selectedHS?.hs}
                          tradeflow='imports'/>
                      </Row>
                    </>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ):''}
    </>
  )
}

export default TradePotentialCommodityPage